import { Button } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { UpsertPromotionRelegationRulesModal } from "~Features/EditSeason/components/PromotionRelegationRules/components/UpsertPromotionRelegationRulesModal.tsx";
import type { PromotionRelegationRuleTableRow } from "~Features/EditSeason/components/PromotionRelegationRules/types/promotionRelegationRuleTableRow.ts";
import type { PromotionRelegationRule } from "~types/promotionRelegationRule.ts";

type Props = {
  row: PromotionRelegationRuleTableRow;
  loading: boolean;
  onSave: () => Promise<void>;
};
export const EditPromotionRelegationRuleAction = ({ row, onSave, loading }: Props) => {
  const [currentRuleId, setCurrentRuleId] = useState<number | null>(null);

  const { formatMessage } = useIntl();

  const handleSave = async (data: PromotionRelegationRule) => {
    if (currentRuleId === null) return;
    row.value = data.value;
    row.ruleType = data.ruleType;
    row.position = data.position;
    await onSave();
    setCurrentRuleId(null);
  };

  return (
    <>
      {currentRuleId === row.id && (
        <UpsertPromotionRelegationRulesModal
          isOpen={currentRuleId !== null && currentRuleId >= 0}
          onCancel={() => setCurrentRuleId(null)}
          loading={loading}
          onOk={handleSave}
          rule={row}
        />
      )}
      <Button
        onClick={() => setCurrentRuleId(row.id)}
        type={"text"}
        size={"small"}
        title={formatMessage({ id: "table.column.actions.modalEdit" })}
        icon={<i className="fas fa-pen-to-square" />}
      />
    </>
  );
};
